import { Card, Row } from 'antd';
import React from 'react';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import ParListSelect from 'components/ParListSelect';
import UtinaCard from 'components/UtinaCard';
import { OnlyIntegerNumber } from 'utils/utils2';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type ContactProps = {
  form: FormInstance;
};

const ContactCard = (props: ContactProps) => {
  return (
    <Card
      style={{
        backgroundColor: '#f7f7f7',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
         
      }}
      title={<GetLabel label="contact" style={{fontWeight:'bold',paddingLeft:15}}/>}
    >
      <Card>
        <Row gutter={16}>
          <UtinaCard
            level={5}
            comcode="primary-contact"
            lg={11}
            style={{ color: '#000' }}
          >
            <Row gutter={16}>
              <FormInput col xs={12} name="tpcontactname1" />
              <FormInput col xs={12} name="tpcontactposition1">
                <ParListSelect parcode="TPMANPOS" />
              </FormInput>
              <FormInput
                col
                xs={12}
                name="tptel1"
                normalize={OnlyIntegerNumber}
              />
               
            
              <FormInput
                col
                xs={12}
                name="tptelmobile1"
                normalize={OnlyIntegerNumber}
              />
                
              <FormInput col xs={24} name="tpemail1" />
            </Row>
          </UtinaCard>

          <UtinaCard
            level={5}
            comcode="secondary-contact"
            style={{ color: '#000' }}
            lg={11}
          >
            <Row gutter={16}>
              <FormInput col xs={12} name="tpcontactname2" />
              <FormInput col xs={12} name="tpcontactposition2">
                <ParListSelect parcode="TPMANPOS" />
              </FormInput>
              <FormInput
                col
                xs={12}
                name="tptel2"
                normalize={OnlyIntegerNumber}
              />
               
              <FormInput
                col
                xs={12}
                name="tptelmobile2"
                normalize={OnlyIntegerNumber}
              />
               
              <FormInput col xs={24} name="tpemail2" />
            </Row>
          </UtinaCard>
        </Row>
      </Card>
    </Card>
  );
};

export default ContactCard;
